import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_327: DocMigration = {
  maxSchemaVersion: "0.0.327",
  description: "Add default elevation view template layers",
  apply(json: any): any {
    for (const viewTemplateId in json.viewTemplates) {
      const viewTemplate = json.viewTemplates[viewTemplateId];
      if (viewTemplate.viewType === "ELEVATION_VIEW") {
        viewTemplate.layers = ["ELEVATION_LINEWORK_3D", "ANNOTATION"];
      }
    }
    return json;
  },
};

export default migration_0_0_327;
